import { Colors } from "@blueprintjs/core";

import { Box } from "@/components/layout/flexbox";
import { Media } from "@/components/layout/Media";

export function EnterPrompt() {
  return (
    <Media greaterThan="xs">
      <Box ml={3} style={{ color: Colors.GRAY3 }}>
        ⏎ Enter
      </Box>
    </Media>
  );
}
